export interface FormattedPart {
  type: "text" | "bold" | "italic" | "escaped" | "linebreak";
  content: string;
}

export const formatDescription = (description: string): FormattedPart[] => {
  const lines = description.split(/\n/);

  const formattedParts: FormattedPart[] = [];

  lines.forEach((line, index) => {
    if (index > 0) {
      formattedParts.push({ type: "linebreak", content: "\n" });
    }

    const parts = line.split(/(\*\*.*?\*\*|\*.*?\*|\\.)/).filter(Boolean);

    parts.forEach((part) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        formattedParts.push({ type: "bold", content: part.slice(2, -2) });
      } else if (part.startsWith("*") && part.endsWith("*")) {
        formattedParts.push({ type: "italic", content: part.slice(1, -1) });
      } else if (part.startsWith("\\")) {
        formattedParts.push({ type: "escaped", content: part.slice(1) });
      } else {
        formattedParts.push({ type: "text", content: part });
      }
    });
  });

  return formattedParts;
};
